import React from 'react';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';

import {
	AvatarFrameVipPng,
	AvatarModalPng,
	NamePng,
	RedChipsPng,
	VipBadgeFramePng,
} from '../../../assets';
import { useDevice } from '../../../utils/hooks/useDevice';

type Props = {
	name: string;
	score: number;
	chips: string;
	isVip: boolean;
	avatarImage: any;
	backgroundImage: any;
};

const InvitedPlayerCard = ({
	name,
	score: _score,
	chips,
	isVip,
	avatarImage,
	backgroundImage,
}: Props) => {
	const { isDesktop } = useDevice();
	const isMobileLayout = !isDesktop;

	return (
		<ImageBackground
			source={backgroundImage}
			resizeMode='stretch'
			style={[
				styles.cardBackground,
				{
					paddingRight: isMobileLayout ? 12 : 0,
					marginLeft: isMobileLayout ? 4 : 14,
				},
			]}
		>
			<View
				style={[
					styles.container,
					{
						gap: isMobileLayout ? 2 : 4,
					},
				]}
			>
				<View
					style={{
						width: isMobileLayout ? 76 : 60,
						height: isMobileLayout ? 56 : 60,
						position: 'relative',
						alignItems: 'center',
						justifyContent: 'center',
						marginLeft: -10,
					}}
				>
					<Image
						source={isVip ? AvatarFrameVipPng : AvatarModalPng}
						style={isVip ? styles.avatarVip : styles.avatarLogoBg}
						// style={{
						//   width: "100%",
						//   height: "100%",
						//   position: "absolute",
						//   top: 0,
						//   left: 0,
						// }}
						resizeMode='contain'
					/>

					<Image
						source={avatarImage}
						style={{
							width: isMobileLayout ? 46 : 42,
							height: isMobileLayout ? 46 : 42,
							borderRadius: (isMobileLayout ? 46 : 42) / 2,
						}}
						resizeMode='cover'
					/>
					{isVip && (
						<Image
							source={VipBadgeFramePng}
							style={{
								position: 'absolute',
								top: 18,
								left: isMobileLayout ? 50 : 40,
								width: 25,
								height: 25,
								zIndex: 22,
							}}
						/>
					)}
				</View>

				{/* Name */}
				<View style={[styles.nameWrapper, { marginTop: isMobileLayout ? 5 : 1 }]}>
					<ImageBackground
						source={NamePng}
						style={{
							width: isMobileLayout ? 120 : 190,
							height: isMobileLayout ? 30 : 28,
						}}
						resizeMode='stretch'
					>
						<Text style={styles.nameText}>{name}</Text>
					</ImageBackground>
				</View>

				{/* Chips */}
				<View style={[styles.statsItem, { marginTop: isMobileLayout ? 2 : 6 }]}>
					<Image source={RedChipsPng} resizeMode='contain' style={styles.statsIcon} />
					<Text style={styles.statsText}>{chips}</Text>
				</View>
			</View>
		</ImageBackground>
	);
};

const styles = StyleSheet.create({
	cardBackground: {
		borderRadius: 12,
		marginBottom: 6,

		height: 60,
		marginLeft: 4,
	},
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatarWrapper: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	avatarBg: {
		position: 'relative',
	},
	avatarLogoBg: {
		width: '100%',
		height: '100%',
		position: 'absolute',
		top: 0,
		left: 0,
	},
	avatarVip: {
		width: '85%',
		height: '85%',
		position: 'absolute',
		top: 4,
		left: 5,
	},
	nameWrapper: {
		position: 'relative',
	},
	nameText: {
		flex: 1,
		color: 'white',
		fontSize: 14,
		fontWeight: '500',
		marginLeft: 3,
		marginTop: 4,
		paddingLeft: 4,
	},
	statsItem: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	},
	statsIcon: {
		width: 24,
		height: 24,
	},
	statsText: {
		color: 'white',
		fontSize: 14,
		marginLeft: 2,
		fontWeight: 'bold',
	},
});

export default InvitedPlayerCard;
